import { LoadingOutlined } from '@ant-design/icons'
import { Button, Col, Row, Spin } from 'antd'
import BonanzaCatalogBanner from 'components/Bonanza/BonanzaCatalogBanner'
import Explore from 'components/Explore'
import { Styled3ColsWrapper } from 'components/GlobalStyles'
import MediumContainer from 'components/MediumContainer'
import MenuCarousel from 'components/MenuCarouselComponent'
import ProductBox from 'components/ProductBox'
import ProductDefaultMain from 'components/ProductDefaultMain'
import ProductsLoader from 'components/ProductsLoader'
import Project350 from 'components/Project350/CatalogBanner/index'
import ScBannerV2 from 'components/SuperCard/SupercardBannerV2'
import { IS_BONANZA_PROMO_ACTIVE } from 'utils/constants'
import ViewContainer from './container'
import { Styled, StyledH2 } from './styles'

export default function Index({ ...pageProps }) {
  return (
    <ViewContainer {...pageProps}>
      {({
        state,
        category,
        products,
        featuredByCategory,
        loadMore,
        recentOrders,
        pageLimit,
        page
      }) => (
        <>
          <Row style={{ marginBottom: 40 }} justify="center">
            <Col span={24}>
              {state.promos.status === 2 ? (
                <MenuCarousel contents={state.promos.payload} />
              ) : (
                <Spin spinning />
              )}
            </Col>
          </Row>
          <MediumContainer>
            {IS_BONANZA_PROMO_ACTIVE ? <Project350 /> : <ScBannerV2 />}
            {state.featuredProducts.status === 1 && (
              <Row style={{ marginBottom: '30px', marginTop: '60px' }}>
                <ProductsLoader isFeatured={true} />
              </Row>
            )}
            {state.featuredProducts.status === 2 &&
              featuredByCategory.length > 0 && (
                <>
                  <Row style={{ marginBottom: '30px', marginTop: '60px' }}>
                    <Col
                      xs={{ span: 18 }}
                      sm={{ span: 18 }}
                      md={{ span: 20 }}
                      lg={{ span: 20 }}
                    >
                      {!category ? (
                        <StyledH2>Featured Products</StyledH2>
                      ) : (
                        <StyledH2>Suggested {category.name} for you.</StyledH2>
                      )}
                    </Col>
                  </Row>
                  <Styled>
                    {state.featuredProducts.status === 2 && (
                      <Row>
                        <Col span={24}>
                          <Styled3ColsWrapper>
                            {featuredByCategory?.length &&
                              featuredByCategory.map((featuredProduct) => (
                                <ProductDefaultMain
                                  key={featuredProduct.id}
                                  product={featuredProduct.product_data}
                                />
                              ))}
                          </Styled3ColsWrapper>
                        </Col>
                      </Row>
                    )}
                  </Styled>
                </>
              )}
            <br />
            {!category &&
              state.recentOrdersState.status === 2 &&
              recentOrders.length > 0 && (
                <Row>
                  <Col span={24}>
                    <StyledH2>Recent Orders</StyledH2>
                  </Col>
                  {recentOrders
                    .slice(0, 3)
                    .filter(
                      (order) =>
                        order.product_details.sku !== 'WTG' &&
                        order.product_details.sku !== 'WTC'
                    )
                    .map((order) => (
                      <ProductBox
                        key={order.id}
                        product={{
                          ...order.product_details,
                          id: order.product_id
                        }}
                        mode="small"
                        isRecentOrder={true}
                        paidPrice={order.price}
                      />
                    ))}
                </Row>
              )}
            {state.products.status === 2 && (
              <Row style={{ marginBottom: '30px', marginTop: '60px' }}>
                <Col
                  xs={{ span: 18 }}
                  sm={{ span: 18 }}
                  md={{ span: 20 }}
                  lg={{ span: 20 }}
                >
                  <StyledH2>
                    All {category && category.name} {!category && 'Products'}
                  </StyledH2>
                </Col>
              </Row>
            )}
            {state.products.status === 2 && products?.length > 0 && (
              <Row>
                {products.map((x, y) => (
                  <ProductBox key={y} product={x.product_data} mode="small" />
                ))}
              </Row>
            )}
            {state.products.status === 1 && (
              <div style={{ marginTop: 30 }}>
                <ProductsLoader />
              </div>
            )}
            {pageLimit && page < pageLimit && (
              <Row>
                <Col
                  xs={{ span: 24, offset: 0 }}
                  sm={{ span: 24, offset: 0 }}
                  md={{ span: 8, offset: 8 }}
                  lg={{ span: 8, offset: 8 }}
                  style={{ marginTop: '10px', marginBottom: '30px' }}
                >
                  <Button
                    disabled={state.products.status === 1}
                    block
                    type="ghost"
                    onClick={loadMore}
                  >
                    LOAD MORE PRODUCTS{' '}
                    {state.products.status === 1 && <LoadingOutlined />}
                  </Button>
                </Col>
              </Row>
            )}
            <Col
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 20 }}
              lg={{ span: 20 }}
            >
              <StyledH2>Explore More</StyledH2>
            </Col>
            <Explore />
            <Col
              style={{ marginTop: '40px' }}
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 24 }}
            />
          </MediumContainer>
        </>
      )}
    </ViewContainer>
  )
}
